import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../Layout";
import HeaderBread from "../../components/HeaderBread";
import MenubarInput from "../../components/Menubar/MenubarInput";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { getMenubarDataById } from "../../utils/ApiCalls/Menubar";

const EditMenubar = () => {
  const params = useParams();
  const [menubar, setMenubar] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    { title: "Home", route: "/" },
    { title: "Menubar", route: "/website/cms/homepage/menubar" },
    { title: "Edit Menu", route: "/website/cms/homepage/menubar/edit" },
  ];

  useEffect(() => {
    getData(params?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const getData = async (id) => {
    dispatch({ type: "SET_LOADING", loading: true });
    let data = await getMenubarDataById(id);
    if (data?.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else {
      setMenubar(data);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  return (
    <Layout type={"update_per"} module_data={"Menubar"}>
      <HeaderBread navigation={navigation} title={"Edit Menu"}></HeaderBread>
      {menubar && <MenubarInput menubar={menubar} />}
    </Layout>
  );
};

export default EditMenubar;
